"use strict";

exports.__esModule = true;
exports.YoLog = exports.DebugFlags = exports.DEBUG_VALIDATION = exports.DEBUG_STATE_MACHINE = exports.DEBUG_REPORTS = exports.DEBUG_POLLING = exports.DEBUG_PLAYBACK = exports.DEBUG_PARSING = exports.DEBUG_LIFECYCLE = exports.DEBUG_HTTP_REQUESTS = exports.DEBUG_ALL = void 0;
var _Logger = require("../Logger");
var _Constant = require("./Constant");
/*
 * COPYRIGHT 2020-2021 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

/**
 * Enumeration of possible debug flags
 * @enum {number}
 * @category Enumerations
 */
var DebugFlags = exports.DebugFlags = Object.freeze({
  /** When set, traces server playback events */
  DEBUG_PLAYBACK: 1,
  /** When set, traces SDK lifecycle */
  DEBUG_LIFECYCLE: 1 << 1,
  /** When set, traces VMAP polling events */
  DEBUG_POLLING: 1 << 2,
  /** When set, traces VMAP and VAST tracking reports */
  DEBUG_REPORTS: 1 << 3,
  /** When set, traces state machine state */
  DEBUG_STATE_MACHINE: 1 << 4,
  /** When set, traces HTTP requests and responses */
  DEBUG_HTTP_REQUESTS: 1 << 5,
  /** When set, traces VAST and VMAP parsing events */
  DEBUG_PARSING: 1 << 6,
  /** When set, traces validation statements */
  DEBUG_VALIDATION: 1 << 7,
  /** When set, enables all trace options */
  DEBUG_ALL: Number.MAX_SAFE_INTEGER
});

/** When set, traces server playback events
 * @deprecated Will be removed in 3.7.0.  Use DebugFlags instead
 * @category Debug Flags */
var DEBUG_PLAYBACK = exports.DEBUG_PLAYBACK = DebugFlags.DEBUG_PLAYBACK;
/** When set, traces SDK lifecycle
 * @deprecated Will be removed in 3.7.0.  Use DebugFlags instead
 * @category Debug Flags */
var DEBUG_LIFECYCLE = exports.DEBUG_LIFECYCLE = DebugFlags.DEBUG_LIFECYCLE;
/** When set, traces VMAP polling events
 * @deprecated Will be removed in 3.7.0.  Use DebugFlags instead
 * @category Debug Flags */
var DEBUG_POLLING = exports.DEBUG_POLLING = DebugFlags.DEBUG_POLLING;
/** When set, traces VMAP and VAST tracking reports
 * @deprecated Will be removed in 3.7.0.  Use DebugFlags instead
 * @category Debug Flags */
var DEBUG_REPORTS = exports.DEBUG_REPORTS = DebugFlags.DEBUG_REPORTS;
/** When set, traces state machine state
 * @deprecated Will be removed in 3.7.0.  Use DebugFlags instead
 * @category Debug Flags */
var DEBUG_STATE_MACHINE = exports.DEBUG_STATE_MACHINE = DebugFlags.DEBUG_STATE_MACHINE;
/** When set, traces HTTP requests and responses
 * @deprecated Will be removed in 3.7.0.  Use DebugFlags instead
 * @category Debug Flags */
var DEBUG_HTTP_REQUESTS = exports.DEBUG_HTTP_REQUESTS = DebugFlags.DEBUG_HTTP_REQUESTS;
/** When set, traces VAST and VMAP parsing events
 * @deprecated Will be removed in 3.7.0.  Use DebugFlags instead
 * @category Debug Flags */
var DEBUG_PARSING = exports.DEBUG_PARSING = DebugFlags.DEBUG_PARSING;
/** When set, traces validation statements
 * @deprecated Will be removed in 3.7.0.  Use DebugFlags instead
 * @category Debug Flags */
var DEBUG_VALIDATION = exports.DEBUG_VALIDATION = DebugFlags.DEBUG_VALIDATION;
/** When set, enables all trace options
 * @deprecated Will be removed in 3.7.0.  Use DebugFlags instead
 * @category Debug Flags */
var DEBUG_ALL = exports.DEBUG_ALL = DebugFlags.DEBUG_ALL;

/**
 * Logging class for the SDK, defining flags that conditionally switch categories of debugging trace statements.
 */
var YoLog = exports.YoLog = /*#__PURE__*/function () {
  function YoLog() {}
  /**
   *        Sets a custom logging implementation
   * @param logger the custom logger
   */
  YoLog.setLogger = function setLogger(logger) {
    YoLog.logger = logger;
  }

  /**
   *        Sets the debug flags, specified as an ORed list, as the list of enabled flags.
   *        By default, no flags are enabled.
   * @param {number} flags the debug flags to use for this session
   */;
  YoLog.setDebugFlags = function setDebugFlags(flags) {
    YoLog.debugflags = flags;
  }

  /**
   *        Get the debug flags, specified as an ORed list, as the list of enabled flags.
   *        By default, no flags are enabled.
   * @return {number} the debug flags in use for this session
   */;
  YoLog.getDebugFlags = function getDebugFlags() {
    return YoLog.debugflags;
  }

  /**
   * Conditionally logs the supplied message if the message category is defined and if *debug*
   * log level is defined.
    @param cat the category (debug flags)
   @param msg the trace message
   */;
  YoLog.d = function d(cat, msg) {
    if (YoLog.debugflags & cat) {
      YoLog.logger.debug((0, _Constant.getLogTag)() + msg);
    }
  }

  /**
   * Logs the supplied error message.
    @param msg the trace message
   */;
  YoLog.e = function e(msg) {
    YoLog.logger.error((0, _Constant.getLogTag)() + msg);
  }

  /**
   * Conditionally logs the supplied message if the message category is defined and if *information*
   * log level is defined.
    @param cat the category (debug flags)
   @param msg the trace message
   */;
  YoLog.i = function i(cat, msg) {
    if (YoLog.debugflags & cat) {
      YoLog.logger.info((0, _Constant.getLogTag)() + msg);
    }
  }

  /**
   * Conditionally logs the supplied warning message if *warning* log level is defined.
    @param msg the trace message
   */;
  YoLog.w = function w(msg) {
    YoLog.logger.warn((0, _Constant.getLogTag)() + msg);
  };
  YoLog.trace = function trace(msg) {
    YoLog.d(DebugFlags.DEBUG_VALIDATION, "[" + Date.now() + "][YoSDK:" + msg + "]");
  };
  return YoLog;
}();
YoLog.debugflags = 0;
YoLog.logger = _Logger.Logger;